import React from 'react'

import { SaveButton, Toolbar, ToolbarProps } from 'react-admin'

export const NoDeleteEditToolbar: React.FC<ToolbarProps> = props => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
)
